import { render, staticRenderFns } from "./NewTreatmentModal.vue?vue&type=template&id=349a6ac0"
import script from "./NewTreatmentModal.vue?vue&type=script&lang=js"
export * from "./NewTreatmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports